import { QuickLink } from '../../../models/quicklink.model';

export interface QuickLinkDataState {
    quickLinkData: QuickLink | null;
}

export const quickLinkInitialState: QuickLinkDataState = {
    quickLinkData: null
};
